import {Vat} from './Vat';

export class Country {
  public id: number;
  public name: string;
  public dateFormat: string;
  public currencyFormat: string;
  public dealerVat = 0;
  public customerVat = 0;
  public currencyDecimals = 2;
  public thousandSeparator: string;
  public decimalSeparator: string;
  public userDateFormat: string;
}
